import BlogArticlePage from '../components/BlogArticles';
import { publicMeta } from './public-meta';

export const meta = publicMeta(
  'Dogstar: episodic content at social media speed | Cartwheel',
  'How an Academy Award-winning director built an episodic animation pipeline at social media speed.',
);

export default BlogArticlePage;
